<script lang="ts">
  import { Button, Col, Container, Row } from "sveltestrap";
  import { AddNewNote, href, StickyNote } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
  import BookmarkSticky from "./BookmarkSticky.svelte";
  import {notes} from "../../../store"
  import Link from "svelte-link";
  let setNotes:any
  notes.subscribe ((value)=>{
    setNotes = value
  })
  const addStickyNote = () => {
    notes.update(value => value = [...setNotes, { id: setNotes.length + 1, isDeleted: false }]);
  }; 
  const deleteNote = (note:any) => {
    notes.update(value => value =[...setNotes, { id: note, isDeleted: true }]);
    note.isDeleted = true;
  }; 

</script>
<BookmarkSticky />
<Container fluid>
  <Row class="sticky-header-main">
    <Col sm="12">
      <Card cardHeaderprops="pb-0">
        <div slot="customheader">
          <h5>{StickyNote} 
            <Button color="primary" on:click={addStickyNote} class="pull-right m-l-10" id="add_new" href={href}>{AddNewNote}</Button>
          </h5>
        </div>
        <div slot="contentbody">
          <div class="CC-note" id="board">
            {#each setNotes as stickyItem,i}
              <div class="note ui-draggable ui-draggable-handle {stickyItem.isDeleted ? 'd-none' : ''}" style="">
                <Link href={href} class="button remove" on:click={() => deleteNote(stickyItem)}>X</Link>
                <div class="note_cnt">
                  <textarea class="title" placeholder="Enter note title" style="height: 64px;"></textarea>
                  <textarea class="cnt" placeholder="Enter note description here" style="height: 200px;"></textarea>
                </div> 
              </div>
            {/each}
          </div>
        </div>
      </Card>
    </Col>
  </Row>
</Container>